import { SET_CARD, REMOVE_CARD } from '../actionsTypes/pinnedArea';

export const setCard = (payload) => ({ type: SET_CARD, payload });

export const removeCard = (payload) => ({ type: REMOVE_CARD, payload });
